// extracted by mini-css-extract-plugin
module.exports = {"root":"TotalCount_root__16Z81"};